import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import ModalDialogMUI6 from 'src/components/ModalDialogMUI6';
import FormCallingYouToConnectYouWith from 'src/components/View/ModalDialogForm/CallingYouToConnectYouWith/FormCallingYouToConnectYouWith';
import { CONTACT_MODAL_FORM_NAMES } from 'src/constants/contacts';
import helpers from 'src/helpers';

function CallingYouToConnectYouWith({
  contact,
  onCloseModal,
  loading = false,
  visibleModalForm = '',
  onSubmitForm = null,
  onSubmitFormRequest = () => {},
}) {
  const {
    firstName,
    lastName,
  } = contact || {};

  const {
    cpVoiceCallingPhone,
    cpVoiceCallingEnabled,
  } = useSelector((state) => state?.account?.user || {});

  const fullName = `${firstName || ''}${firstName && lastName ? ' ' : ''} ${lastName || ''}`;

  return (
    <ModalDialogMUI6
      onClose={onCloseModal}
      isVisible={visibleModalForm === CONTACT_MODAL_FORM_NAMES.MODAL_CALLING_YOU_TO_CONNECT_YOU_WITH && cpVoiceCallingEnabled && !helpers.isEmpty(cpVoiceCallingPhone)}
      content={(
        <FormCallingYouToConnectYouWith
          loading={loading}
          contact={contact}
          onCloseModal={onCloseModal}
          onSubmitForm={onSubmitForm}
          onSubmitFormRequest={onSubmitFormRequest}
        />
      )}
      title={(
        <Box
          sx={{
            paddingTop: '24px',
            fontWeight: 'normal',
            fontSize: '22px',
            lineHeight: '1.4em',
          }}
        >
          Calling you at
          {' '}
          <b>
            {helpers.transform.toPhoneNumber(cpVoiceCallingPhone)}
          </b>
          {' '}
          to Connect you with
          {' '}
          <b>
            {fullName}
          </b>
        </Box>
      )}
      loading={loading}
      okText="OK"
      onOk={() => {}}
      okButtonProps={{
        form: 'formCallingYouToConnectYouWith',
        type: 'primary',
      }}
      buttonsListOrder={['ok']}
    />
  );
}

CallingYouToConnectYouWith.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  onSubmitForm: PropTypes.func,
  onSubmitFormRequest: PropTypes.func,
  loading: PropTypes.bool,
  visibleModalForm: PropTypes.string,
};

export default CallingYouToConnectYouWith;
